import { render, staticRenderFns } from "./pbi-dealer-profile.page.vue?vue&type=template&id=88ddfd0e"
import script from "./pbi-dealer-profile.page.vue?vue&type=script&lang=ts"
export * from "./pbi-dealer-profile.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports